import { Component, Input, HostListener } from '@angular/core';
import { TableEditableService } from '../table-editable.service';


@Component({
  moduleId: module.id,
  selector: 'editable-details-icon',
  templateUrl: 'editable-details-icon.component.html',
  styleUrls: ['editable-details-icon.component.scss'],
})
export class EditableDetailsIconComponent {

  @Input() selected: boolean = false;

  @Input() up: boolean = false;

  @Input() row: any;

  @Input() plusIcon: boolean = false;

  @Input() text: string;

  constructor(
    private editableService: TableEditableService
  ) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    if (this.editableService.isEditing) {
      event.stopPropagation();
    }
  }

  onChange(selected: boolean) {
    if (selected) { return this.editableService.selectRow(this.row); }
    this.editableService.unselectRow(this.row);
  }

  toggle() {
    this.up = !this.up;
  }

  unselect() {
    this.selected = false;
    this.editableService.unselectRow(this.row);
  }

}
